"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _row = _interopRequireDefault(require("../../../../core/row"));
var _col = _interopRequireDefault(require("../../../../core/col"));
var _input = _interopRequireDefault(require("../../../../core/input"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const weekDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
var _ref = /*#__PURE__*/_react.default.createElement("p", {
  className: "text-danger"
}, "WARNING: This application will be marked as late and show in red on the calendar");
var _ref2 = /*#__PURE__*/_react.default.createElement("br", null);
class TierRacingDays extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "_getRacingOptions", dayID => {
      if (dayID === 0) {
        return [{
          id: 'NEW',
          description: 'New Race'
        }, {
          id: 'NONE',
          description: 'No Racing'
        }];
      }
      return [{
        id: 'NEW',
        description: 'New Race'
      }, {
        id: 'CONT',
        description: 'Racing continued from previous day (eg Prem finals)'
      }, {
        id: 'NONE',
        description: 'No Racing'
      }];
    });
  }
  render() {
    const tier = this.props.defaultTier;
    const today = new Date().toISOString().split('T')[0];
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "card",
      key: tier.tierRef
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "card-header"
    }, tier.tierDescription), /*#__PURE__*/_react.default.createElement("div", {
      className: "card-block"
    }, !tier.applicationClosingDate || tier.applicationClosingDate > today ? null : _ref, this.props.competitionDays.map(day => /*#__PURE__*/_react.default.createElement(_row.default, {
      key: day.id
    }, _ref2, /*#__PURE__*/_react.default.createElement(_col.default, {
      sm: 3,
      lg: 4
    }, weekDays[day.weekDay]), /*#__PURE__*/_react.default.createElement(_col.default, {
      sm: 9,
      lg: 8
    }, this._getRacingOptions(day.id).map(opt => /*#__PURE__*/_react.default.createElement("span", {
      key: opt.id
    }, /*#__PURE__*/_react.default.createElement(_input.default, {
      type: "Radio",
      name: tier.tierRef + ' racingOption ' + day.id,
      value: opt.id,
      checked: this.props.tierRacingOptions[day.id] === opt.id,
      onChange: this.props.onChange.bind(this, day.id),
      label: ' ' + opt.description
    }))))))));
  }

  // *******************************************************************************
  // Partial Queries
  // *******************************************************************************
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(TierRacingDays, "partialQueries", {
  DefaultTier: {
    tierRef: true,
    tierDescription: true,
    applicationClosingDate: true
  }
});
var _default = exports.default = TierRacingDays;